module.exports = __webpack_public_path__ + "img/info-trans.7a5d4c36.jpeg";